// extracted by mini-css-extract-plugin
module.exports = {"main":"bz_n","feature":"bz_bj","label":"bz_6","title":"bz_p","pagraph":"bz_bm","imgContainer":"bz_bq","banner":"bz_J","bannerBlue":"bz_hl"};